import { useState, useEffect } from "react";
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  LinearProgress,
  TextareaAutosize,
  TextField,
  Typography,
} from "@mui/material";
import { useAppSelector, useAppDispatch } from "../hooks";
import CssBaseline from '@mui/material/CssBaseline';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Logo from "../assets/images/login-logo.png";
import Logo2 from "../assets/images/VBM_LOGO_FULL.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useForm, Resolver } from "react-hook-form";
import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { setUserValues } from "../slices/userSlice";
import { setApplicationValues, setPageTitle } from "../slices/applicationSlice";
import { IApplication } from "../interfaces/IApplication";
import CloseIcon from '@mui/icons-material/Close';



const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#666666' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  border: 0,
  borderRadius: 0,
  boxShadow: "none",
}));

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2, }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

function Copyright(props: any) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="#">
        VBM Hort
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}


const theme = createTheme();

type FormValues = {
  email: string;
  password: string;
};

const resolver: Resolver<FormValues> = async (values) => {
  return {
    values: values.email ? values : {},
    errors: !values.email
      ? {
        email: {
          type: 'required',
          message: 'This is required.',
        },
      }
      : {},
  };
};

export default function SignIn() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { register, handleSubmit, formState: { errors } } = useForm<FormValues>({ resolver });

  useEffect(() => {
    let appState: IApplication = {
      pageTitle: "Login",
      backgroundPath: "/assets/images/loginbg.jpg",
      loggedInUser: null
    }
    dispatch(setPageTitle(appState));
    dispatch(setApplicationValues(appState));
  }, []);


  const onSubmit = handleSubmit((data) => {
    console.log(data);
    axios.post(`${process.env.REACT_APP_ENDPOINT}/api/Users/Login`, {
      email: data.email, password: data.password
    }).then((data) => {
      console.log("DATA", data);
      if (data.status === 200) {
        var userResult = data.data;
        let applicationObject: IApplication = {
          loggedInUser: userResult,
          backgroundPath: ""
        }
        dispatch(setApplicationValues(applicationObject));
        navigate("/main/maindashboard")
      };
      console.log(data);
    });
  });

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    border: 0,
    borderRadius: 0,
    boxShadow: "none",
  }));

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const darkTheme = createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: '#89B219',
      },
    },
  });

  return (
    <div>
      <Container component="main" maxWidth="md" >
        <Box
          height='80vh'
          justifyContent="center"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Grid container spacing={0}
            borderRadius="30px"
            padding={4}
            sx={{
              bgcolor: 'rgba(255, 255, 255, 0.9)'
            }}
          >
            <Grid item xs={7}>
              <Item sx={{
                bgcolor: 'transparent'
              }}>
                <Box
                  justifyContent="center"
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <img src={Logo2} width='100%' />
                </Box>
              </Item>
            </Grid>

            <Grid item xs={5}>
              <Item sx={{
                bgcolor: 'transparent'
              }}>
                <Box
                  justifyContent="center"
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >

                  <img src={Logo} width='60%' />
                </Box>
              </Item>
            </Grid>

            <Grid item xs={12}>
              <Item sx={{ bgcolor: 'transparent' }}>
                <Box component="form" onSubmit={onSubmit} sx={{ mt: 1 }}>
                  <TextField
                    required
                    fullWidth
                    margin="dense"
                    id="employeeid"
                    label="Employee ID"
                    autoComplete="employeeid"
                    variant="filled" color="primary"
                    {...register("email")}
                  />
                  <TextField
                    margin="dense"
                    required
                    fullWidth
                    label="Password"
                    type="password"
                    id="password"
                    autoComplete="current-password"
                    variant="filled" color="primary"
                    {...register("password")}
                  />
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    sx={{ mt: 3, mb: 2, p: 2 }}
                    size="large"
                  >
                    <Typography variant="h5" color="#FFF">
                      Sign-In
                    </Typography>
                  </Button>
                  <Grid container>
                    <Grid item xs>
                      <Button color="inherit" onClick={handleClickOpen} size="large">
                        Forgot Password?
                      </Button>

                      <Typography variant="h6" color="#666" sx={{ mt: 2, fontSize: 13 }}>
                        © Copyright VBM Hort 2023  |  Version:1.0.0
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Item>
            </Grid>
          </Grid>
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>

      <div>
        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
        >
          <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
            Forgot Password?
          </BootstrapDialogTitle>
          <DialogContent dividers>
            <DialogContentText>
              To reset your password, please enter your employee ID.
            </DialogContentText>
            <TextField
              color="success"
              autoFocus
              margin="dense"
              id="name"
              label="Employee ID"
              type="email"
              fullWidth
              variant="filled"
            />
            <TextField
              color="success"
              autoFocus
              margin="dense"
              id="name"
              label="What is your mother's maiden name?"
              type="email"
              fullWidth
              variant="filled"
            />
          </DialogContent>
          <DialogActions>
            <Button color="primary" variant="outlined" onClick={handleClose}>Cancel</Button>
            <Button color="success" variant="contained" onClick={handleClose}>Reset Password</Button>
          </DialogActions>
        </BootstrapDialog>
      </div>

    </div>
  );
}